import { Component } from '@angular/core';

@Component({
    selector: 'app-send-docs-by-post-component',
    templateUrl: './send-docs-by-post.component.html',
    styleUrls: [],
})
export class SendDocsByPostComponent {}
